<template>
<svg viewBox="0 0 18 18" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-PingMu`]" width="1em" height="1em" v-bind="$attrs"><path transform="rotate(60 10.698 5.479)" d="M10.698 5.479H11.858V10.118H10.698z"/><path transform="rotate(60 10.835 9.006)" d="M10.835 9.006H11.995000000000001V11.325H10.835z"/><path transform="rotate(60 7.86 10.768)" d="M7.859 10.768H9.019V11.928H7.859z"/><path d="M12.8649 1H5.13514C4.70147 1 4.28557 1.18179 3.97892 1.50538C3.67227 1.82898 3.5 2.26786 3.5 2.72549V15.2745C3.5 15.7321 3.67227 16.171 3.97892 16.4946C4.28557 16.8182 4.70147 17 5.13514 17H12.8649C13.2985 17 13.7144 16.8182 14.0211 16.4946C14.3277 16.171 14.5 15.7321 14.5 15.2745V2.72549C14.5 2.26786 14.3277 1.82898 14.0211 1.50538C13.7144 1.18179 13.2985 1 12.8649 1ZM5.13514 1.94118H12.8649C13.062 1.94118 13.251 2.02381 13.3904 2.1709C13.5298 2.31798 13.6081 2.51748 13.6081 2.72549V15.2745C13.6081 15.4825 13.5298 15.682 13.3904 15.8291C13.251 15.9762 13.062 16.0588 12.8649 16.0588H5.13514C4.93802 16.0588 4.74897 15.9762 4.60958 15.8291C4.4702 15.682 4.39189 15.4825 4.39189 15.2745V2.72549C4.39189 2.51748 4.4702 2.31798 4.60958 2.1709C4.74897 2.02381 4.93802 1.94118 5.13514 1.94118Z"/></svg>
</template>
<script>

export default {
  name: 'IconPingMu',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
